module.exports = __webpack_public_path__ + "482c101d632462044d32ab897f694296.svg";